import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Text, Preset, FunctionColor } from '@lux/text';

import * as S from './tab.styles';

export class Tab extends PureComponent {
    static propTypes = {
        index: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        active: PropTypes.bool.isRequired,
        onAction: PropTypes.func.isRequired,
    };

    render() {
        const { active, name } = this.props;

        return (
            <S.Button onClick={this.handleAction} active={active} role="tab" aria-selected={active}>
                <Text preset={Preset.S} bold color={FunctionColor.function100}>
                    {name}
                </Text>
            </S.Button>
        );
    }

    handleAction = () => {
        const { onAction, index } = this.props;
        onAction(index);
    };
}

export default Tab;
